import React from 'react';
import { useHistory, useParams } from 'react-router';
import { useAuth } from '../../hooks/useAuth';
import ZenLoading from '../../components/loading/Loading';
import SiteSlide from './components/SiteSlide';
import { useGetAccountQuery, useGetDesignsQuery } from '../../generated/types';
import MenuSlide from './components/core/MenuSlide';
import NoItemCard from '../../components/common/NoItemCard';
import { coreAppUrl, siteUrl } from '../../shared/url';
import BaseLayout from '../../components/layout/BaseLayout';

const HomePage: React.FC = () => {
    useAuth();
    const history = useHistory();
    const { accountId } = useParams<{ accountId: string }>();
    const rowPerPage = 50;

    const { data: accountData } = useGetAccountQuery({
        variables: {
            id: parseInt(accountId + '', 10),
        },
        fetchPolicy: 'no-cache',
    });
    const { loading: isCoreDesignLoading, data: coreDesigns } = useGetDesignsQuery({
        variables: { limit: rowPerPage, offset: 0 },
        fetchPolicy: 'no-cache',
    });

    const onClickCreateNewBioSite = () => {
        history.push(`/account/${accountId}/select-theme`);
    };

    return !accountData || isCoreDesignLoading ? (
        <div className="flex items-center justify-center flex-auto">
            <ZenLoading />
        </div>
    ) : (
        <BaseLayout containerClass={'lg:max-w-1200'}>
            <div className="flex flex-col flex-auto pt-22 pb-28 bg-primary-10 px-24 overflow-y-auto">
                <div className="mb-16 text-left">
                    <div className="font-bold text-24 leading-none">Menus</div>
                </div>
                {coreDesigns?.designs?.edges.length ? (
                    <MenuSlide designs={coreDesigns?.designs} accountId={Number(accountId)} />
                ) : (
                    <div className={'bg-white rounded-10 p-20 mb-20'}>
                        <NoItemCard
                            imageIcon={
                                <img
                                    className={'w-75'}
                                    src={`${siteUrl()}/images/core/no-menu.png`}
                                    alt="create new menu"
                                />
                            }
                            title={'Create a free digital menu'}
                            subtitle={
                                'Create a digital menu for your food service business that looks great, and is easy to update..'
                            }
                            onClickBtn={() => {
                                window.location.href = coreAppUrl(`/account/${accountId}/menus?modal=MENU_CREATE`);
                            }}
                            textBtn={'New Menu'}
                        />
                    </div>
                )}

                <div className="mb-16 text-left">
                    <div className="font-bold text-24 leading-none">Website</div>
                </div>
                <div>
                    {accountData.account.siteDesign ? (
                        <SiteSlide
                            siteDesign={{
                                ...accountData.account.siteDesign,
                                name: accountData.account.name + ' Website',
                                accountId: accountData.account.id,
                                path: accountData.account.username,
                            }}
                            account={accountData.account}
                        />
                    ) : (
                        <div className={'bg-white rounded-10 p-20 mb-20'}>
                            <NoItemCard
                                imageIcon={
                                    <img
                                        className={'w-75'}
                                        src={`${siteUrl()}/images/create-site.png`}
                                        alt="create new menu"
                                    />
                                }
                                title={'Create a simple website'}
                                subtitle={
                                    'Create a free, fully customizable digital store front for your food service business.'
                                }
                                onClickBtn={onClickCreateNewBioSite}
                                textBtn={'New Website'}
                            />
                        </div>
                    )}
                </div>
            </div>
        </BaseLayout>
    );
};

export default HomePage;
